import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../shared/services/http-client/http-client.service';
import {
  CreateInstitutoParamDocCommandDto,
  DocumentoTipoResponseDto,
  InstitutoParamDocResponseDto,
  InstitutosParamDocsQueryParams,
  InstitutosParamDocsResponseDto,
  PatchInstitutoParamDocStatusCommandDto,
  TiposDocumentoQueryParams,
} from '../../models/parametros/instituto-param-doc-api.model';

const INSTITUTOS_PARAM_DOCS_BASE_PATH = '/v1/institutos-param-docs';
const TIPOS_DOCUMENTO_BASE_PATH = '/v1/tipos-documento';

@Injectable({
  providedIn: 'root',
})
export class InstitutosParamDocsApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  listarDocumentos(params?: InstitutosParamDocsQueryParams): Observable<InstitutosParamDocsResponseDto> {
    return this.httpClient.get<InstitutosParamDocsResponseDto>(INSTITUTOS_PARAM_DOCS_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  criarDocumento(command: CreateInstitutoParamDocCommandDto): Observable<InstitutoParamDocResponseDto> {
    return this.httpClient.post<InstitutoParamDocResponseDto>(INSTITUTOS_PARAM_DOCS_BASE_PATH, command);
  }

  alterarStatusDocumento(
    id: number,
    command: PatchInstitutoParamDocStatusCommandDto,
  ): Observable<InstitutoParamDocResponseDto> {
    return this.httpClient.patch<InstitutoParamDocResponseDto>(
      `${INSTITUTOS_PARAM_DOCS_BASE_PATH}/${id}/status`,
      command,
    );
  }

  listarTiposDocumento(params?: TiposDocumentoQueryParams): Observable<DocumentoTipoResponseDto[]> {
    return this.httpClient.get<DocumentoTipoResponseDto[]>(TIPOS_DOCUMENTO_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  private toHttpParams(params?: InstitutosParamDocsQueryParams | TiposDocumentoQueryParams): HttpParams | undefined {
    if (!params) {
      return undefined;
    }

    let httpParams = new HttpParams();

    for (const [chave, valor] of Object.entries(params)) {
      if (valor != null && valor !== '') {
        httpParams = httpParams.set(chave, String(valor));
      }
    }

    return httpParams.keys().length > 0 ? httpParams : undefined;
  }
}
